const validate = (values) => {
  const errors = {};

  if (!values.reason) {
    errors.reason = 'Please enter a reason for cancellation';
  }

  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/desktop/components/cancel-purchase/validate.js